import { EmailTemplateContext, EmailTemplateEntity } from "./template/template";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { AppHelper } from "../appHelper";
import { AppBaseProps, CommonApp, Metadata } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import { EmailDataSourceEntity } from "./dataSource/dataSource";
import React from "react";
export default class SQLLabel extends React.Component<SQLLabelProps, SQLLabelState>{
    private metaData: Metadata;
    constructor(props: SQLLabelProps) {
        super(props)
        this.state = {
            type: props.entity.Type
        }
        this.initApp();
    }

    private initApp = () => {
        this.metaData = {
            pageTitle: Helper.getTranslation("WebSMS.Title.DataSourceEditing"),
            menuDataSource: [
                {
                    type: "save"
                },
                {
                    text: this.props.context.translations["WebCRM.Email.ExecuteSQL"],
                    onClick: "executeSQL()",
                    icon: "caret-circle-right",
                    floating: true,
                    floatingColor: "#00c853",
                    show: "showExecuteButton"
                }
            ],
            tabs: [
                {
                    title: "",
                    moduleName: "app/email/dataSource/dataSourceEditor",
                    iconName: "database"
                }
            ],
            additional: {
                objects: []
            }
        };
    }

    private openEditor = () => {
        const props: EditorProps = {
            context: {},
            dataSources: {},
            entity: {
                Content: this.props.value,
                Id: kendo.guid(),
                IsNew: false,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                Type: this.props.entity.Type,
                IndividualFields: {

                }
            },
            isWindow: false,
            metadata: this.metaData,
            onChange: (sql: string) => {
                this.props.onChange(this.props.field, sql);
            },
            title: null
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(Editor, props)
        })
    }

    componentDidUpdate() {
        if (this.state.type !== this.props.entity.Type) {
            this.setState({ type: this.props.entity.Type })
        }
    }

    render() {
        const buttons = [];

        if (Helper.isNullOrEmpty(this.props.value)) {
            buttons.push((
                <React.Fragment key={kendo.guid()}>
                    <Button onClick={this.openEditor}>
                        <i className="fal fa-plus fa-2x" style={{ marginRight: "5px" }}></i>
                        <label style={{ cursor: "pointer" }}>
                            {this.props.context.translations["WebCRM.Email.AddSQL"]}
                        </label>
                    </Button>
                </React.Fragment>
            ));
        } else {
            buttons.push((
                <React.Fragment key={kendo.guid()}>
                    <Button onClick={this.openEditor}>
                        <i className="fal fa-pen fa-2x" style={{ marginRight: "5px" }}></i>
                        <label style={{ cursor: "pointer" }}>
                            {this.props.context.translations["WebCRM.Email.EditSQL"]}
                        </label>
                    </Button>
                </React.Fragment>
            ));
            buttons.push((
                <React.Fragment key={kendo.guid()}>
                    <Button onClick={() => { this.props.onChange(this.props.field, null); }}>
                        <i className="fal fa-times fa-2x" style={{ marginRight: "5px" }}></i>
                        <label style={{ cursor: "pointer" }}>
                            {this.props.context.translations["WebCRM.Email.RemoveSQL"]}
                        </label>
                    </Button>
                </React.Fragment>
            ));
        }
        return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                {buttons}
            </div>
        );
    }
}

interface SQLLabelProps extends BaseComponentProps {
    value: string;
    entity: EmailTemplateEntity;
    context: EmailTemplateContext;
}

interface SQLLabelState {
    type: number;
}

interface ButtonProps extends React.PropsWithChildren { onClick: () => void }
class Button extends React.Component<ButtonProps, { onHover: boolean }>{

    constructor(props) {
        super(props)
        this.state = {
            onHover: false
        }
    }
    render() {

        const style: React.CSSProperties = {
            width: "auto",
            height: "35px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            border: "1.75px solid var(--secondary-color)",
            backgroundColor: `var(${this.state.onHover ? "--secondary-color" : " --primary-color"})`,
            color: "white",
            padding: "3px"
        };


        return (
            <div style={{ margin: "5px" }}>
                <div
                    style={style}
                    onMouseOver={() => { this.setState({ onHover: true }) }}
                    onMouseLeave={() => { this.setState({ onHover: false }) }}
                    onClick={this.props.onClick}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

class Editor extends React.Component<EditorProps, any> {
    common = new AppHelper();
    showExecuteButton: boolean = false;

    constructor(props) {
        super(props);
        this.showExecuteButton = !Helper.isNullOrEmpty(this.props.entity.Content);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Content":
                this.showExecuteButton = !Helper.isNullOrEmpty(value);
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = () => {
        this.props.onChange(Helper.isStringEmpty(this.props.entity.Content) ? null : this.props.entity.Content);
        this.common.handlePostSave(true, true);
    }

    executeSQL = () => {
        General.Sheet.Manager.getTopMostSheet().trigger(SheetEventType.Custom, { cmd: "executeSQL" });
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }

}

interface EditorProps extends AppBaseProps {
    entity: EmailDataSourceEntity;
    onChange: (sql: string) => void;
}
